module.exports = __webpack_public_path__ + "static/media/ostomy_application.a6db8d53.svg";